export default __webpack_public_path__ + "static/media/Hi-Potion_KHIII.571678a6.webp";